import styled from 'styled-components';
const { SIZES } = require('common/constants/sizes');

export const StyledCell = styled.div`
  font-size: ${SIZES.medium};
  display: flex;
  align-items: center;
  & .MuiAvatar-img,
  & .MuiAvatarGroup-avatar {
    width: 30px;
    height: 30px;
  }
`;
